"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAddressFromOutputScript = exports.createOutputScriptFromAddress = exports.locktimeToNumber = exports.isPublicKeyHashLength = exports.decodeBitcoinAddress = exports.encodeToBitcoinAddress = exports.hashLEToBigNumber = exports.computeHash256 = exports.computeHash160 = exports.createKeyRing = exports.compressPublicKey = exports.isCompressedPublicKey = exports.decomposeRawTransaction = exports.targetToDifficulty = exports.bitsToTarget = exports.deserializeBlockHeader = exports.serializeBlockHeader = exports.TransactionHash = void 0;
const bcoin_1 = __importStar(require("bcoin"));
const wif_1 = __importDefault(require("wif"));
const bufio_1 = __importDefault(require("bufio"));
const hash160_1 = __importDefault(require("bcrypto/lib/hash160"));
const sha256_browser_js_1 = __importDefault(require("bcrypto/lib/sha256-browser.js"));
const ethers_1 = require("ethers");
const hex_1 = require("./hex");
const bitcoin_network_1 = require("./bitcoin-network");
/**
 * Represents a transaction hash (or transaction ID) as an un-prefixed hex
 * string. This hash is supposed to have the same byte order as used by the
 * Bitcoin block explorers which is the opposite of the byte order used
 * by the Bitcoin protocol internally. That means the hash must be reversed in
 * the use cases that expect the Bitcoin internal byte order.
 */
class TransactionHash extends hex_1.Hex {
}
exports.TransactionHash = TransactionHash;
/**
 * Serializes a BlockHeader to the raw representation.
 * @param blockHeader - block header.
 * @returns Serialized block header.
 */
function serializeBlockHeader(blockHeader) {
    const buffer = Buffer.alloc(80);
    buffer.writeUInt32LE(blockHeader.version, 0);
    blockHeader.previousBlockHeaderHash.toBuffer().copy(buffer, 4);
    blockHeader.merkleRootHash.toBuffer().copy(buffer, 36);
    buffer.writeUInt32LE(blockHeader.time, 68);
    buffer.writeUInt32LE(blockHeader.bits, 72);
    buffer.writeUInt32LE(blockHeader.nonce, 76);
    return hex_1.Hex.from(buffer);
}
exports.serializeBlockHeader = serializeBlockHeader;
/**
 * Deserializes a block header in the raw representation to BlockHeader.
 * @param rawBlockHeader - BlockHeader in the raw format.
 * @returns Block header as a BlockHeader.
 */
function deserializeBlockHeader(rawBlockHeader) {
    const buffer = rawBlockHeader.toBuffer();
    const version = buffer.readUInt32LE(0);
    const previousBlockHeaderHash = buffer.slice(4, 36);
    const merkleRootHash = buffer.slice(36, 68);
    const time = buffer.readUInt32LE(68);
    const bits = buffer.readUInt32LE(72);
    const nonce = buffer.readUInt32LE(76);
    return {
        version: version,
        previousBlockHeaderHash: hex_1.Hex.from(previousBlockHeaderHash),
        merkleRootHash: hex_1.Hex.from(merkleRootHash),
        time: time,
        bits: bits,
        nonce: nonce,
    };
}
exports.deserializeBlockHeader = deserializeBlockHeader;
/**
 * Converts a block header's bits into target.
 * @param bits - bits from block header.
 * @returns Target as a BigNumber.
 */
function bitsToTarget(bits) {
    // A serialized 80-byte block header stores the `bits` value as a 4-byte
    // little-endian hexadecimal value in a slot including bytes 73, 74, 75, and
    // 76. This function's input argument is expected to be a numerical
    // representation of that 4-byte value reverted to the big-endian order.
    // For example, if the `bits` little-endian value in the header is
    // `0xcb04041b`, it must be reverted to the big-endian form `0x1b0404cb` and
    // turned to a decimal number `453248203` in order to be used as this
    // function's input.
    //
    // The `bits` 4-byte big-endian representation is a compact value that works
    // like a base-256 version of scientific notation. It encodes the target
    // exponent in the first byte and the target mantissa in the last three bytes.
    // Referring to the previous example, if `bits = 453248203`, the hexadecimal
    // representation is `0x1b0404cb` so the exponent is `0x1b` while the mantissa
    // is `0x0404cb`.
    //
    // To extract the exponent, we need to shift right by 3 bytes (24 bits),
    // extract the last byte of the result, and subtract 3 (because of the
    // mantissa length):
    // - 0x1b0404cb >>> 24 = 0x0000001b
    // - 0x0000001b & 0xff = 0x1b
    // - 0x1b - 3 = 24 (decimal)
    //
    // To extract the mantissa, we just need to take the last three bytes:
    // - 0x1b0404cb & 0xffffff = 0x0404cb = 263371 (decimal)
    //
    // The final difficulty can be computed as mantissa * 256^exponent:
    // - 263371 * 256^24 =
    // 1653206561150525499452195696179626311675293455763937233695932416 (decimal)
    //
    // Sources:
    // - https://developer.bitcoin.org/reference/block_chain.html#target-nbits
    // - https://wiki.bitcoinsv.io/index.php/Target
    const exponent = ((bits >>> 24) & 0xff) - 3;
    const mantissa = bits & 0xffffff;
    const target = ethers_1.BigNumber.from(mantissa).mul(ethers_1.BigNumber.from(256).pow(exponent));
    return target;
}
exports.bitsToTarget = bitsToTarget;
/**
 * Converts difficulty target to difficulty.
 * @param target - difficulty target.
 * @returns Difficulty as a BigNumber.
 */
function targetToDifficulty(target) {
    const DIFF1_TARGET = ethers_1.BigNumber.from("0xffff0000000000000000000000000000000000000000000000000000");
    return DIFF1_TARGET.div(target);
}
exports.targetToDifficulty = targetToDifficulty;
/**
 * Decomposes a transaction in the raw representation into version, vector of
 * inputs, vector of outputs and locktime.
 * @param rawTransaction - Transaction in the raw format.
 * @returns Transaction data with fields represented as un-prefixed hex strings.
 */
function decomposeRawTransaction(rawTransaction) {
    const toHex = (bufferWriter) => {
        return bufferWriter.render().toString("hex");
    };
    const vectorToRaw = (elements) => {
        const buffer = bufio_1.default.write();
        buffer.writeVarint(elements.length);
        for (const element of elements) {
            element.toWriter(buffer);
        }
        return toHex(buffer);
    };
    const getTxInputVector = (tx) => {
        return vectorToRaw(tx.inputs);
    };
    const getTxOutputVector = (tx) => {
        return vectorToRaw(tx.outputs);
    };
    const getTxVersion = (tx) => {
        const buffer = bufio_1.default.write();
        buffer.writeU32(tx.version);
        return toHex(buffer);
    };
    const getTxLocktime = (tx) => {
        const buffer = bufio_1.default.write();
        buffer.writeU32(tx.locktime);
        return toHex(buffer);
    };
    const tx = bcoin_1.TX.fromRaw(Buffer.from(rawTransaction.transactionHex, "hex"), null);
    return {
        version: getTxVersion(tx),
        inputs: getTxInputVector(tx),
        outputs: getTxOutputVector(tx),
        locktime: getTxLocktime(tx),
    };
}
exports.decomposeRawTransaction = decomposeRawTransaction;
/**
 * Checks whether given public key is a compressed Bitcoin public key.
 * @param publicKey - Public key that should be checked.
 * @returns True if the key is a compressed Bitcoin public key, false otherwise.
 */
function isCompressedPublicKey(publicKey) {
    // Must have 33 bytes and 02 or 03 prefix.
    return (publicKey.length == 66 &&
        (publicKey.substring(0, 2) == "02" || publicKey.substring(0, 2) == "03"));
}
exports.isCompressedPublicKey = isCompressedPublicKey;
/**
 * Compresses the given uncompressed Bitcoin public key.
 * @param publicKey Uncompressed 64-byte public key as an unprefixed hex string.
 * @returns Compressed 33-byte public key prefixed with 02 or 03.
 */
function compressPublicKey(publicKey) {
    if (typeof publicKey === "string") {
        publicKey = hex_1.Hex.from(publicKey);
    }
    publicKey = publicKey.toString();
    // Must have 64 bytes and no prefix.
    if (publicKey.length != 128) {
        throw new Error("The public key parameter must be 64-byte. Neither 0x nor 04 prefix is allowed");
    }
    // The X coordinate is the first 32 bytes.
    const publicKeyX = publicKey.substring(0, 64);
    // The Y coordinate is the next 32 bytes.
    const publicKeyY = publicKey.substring(64);
    let prefix;
    if (ethers_1.BigNumber.from(`0x${publicKeyY}`).mod(2).eq(0)) {
        prefix = "02";
    }
    else {
        prefix = "03";
    }
    return `${prefix}${publicKeyX}`;
}
exports.compressPublicKey = compressPublicKey;
/**
 * Creates a Bitcoin key ring based on the given private key.
 * @param privateKey Private key that should be used to create the key ring
 * @param witness Flag indicating whether the key ring will create witness
 *        or non-witness addresses
 * @returns Bitcoin key ring.
 */
function createKeyRing(privateKey, witness = true) {
    const decodedPrivateKey = wif_1.default.decode(privateKey);
    return new bcoin_1.default.KeyRing({
        witness: witness,
        privateKey: decodedPrivateKey.privateKey,
        compressed: decodedPrivateKey.compressed,
    });
}
exports.createKeyRing = createKeyRing;
/**
 * Computes the HASH160 for the given text.
 * @param text - Text the HASH160 is computed for.
 * @returns Hash as a 20-byte un-prefixed hex string.
 */
function computeHash160(text) {
    return hash160_1.default.digest(Buffer.from(text, "hex")).toString("hex");
}
exports.computeHash160 = computeHash160;
/**
 * Computes the double SHA256 for the given text.
 * @param text - Text the double SHA256 is computed for.
 * @returns Hash as a 32-byte un-prefixed hex string.
 */
function computeHash256(text) {
    const firstHash = sha256_browser_js_1.default.digest(text.toBuffer());
    const secondHash = sha256_browser_js_1.default.digest(firstHash);
    return hex_1.Hex.from(secondHash);
}
exports.computeHash256 = computeHash256;
/**
 * Converts a hash in hex string in little endian to a BigNumber.
 * @param hash - Hash in hex-string format.
 * @returns BigNumber representation of the hash.
 */
function hashLEToBigNumber(hash) {
    return ethers_1.BigNumber.from(hash.reverse().toPrefixedString());
}
exports.hashLEToBigNumber = hashLEToBigNumber;
/**
 * Encodes a public key hash into a P2PKH/P2WPKH address.
 * @param publicKeyHash - public key hash that will be encoded. Must be an
 *        unprefixed hex string (without 0x prefix).
 * @param witness - If true, a witness public key hash will be encoded and
 *        P2WPKH address will be returned. Returns P2PKH address otherwise
 * @param network - Network the address should be encoded for.
 * @returns P2PKH or P2WPKH address encoded from the given public key hash
 * @throws Throws an error if network is not supported.
 */
function encodeToBitcoinAddress(publicKeyHash, witness, network) {
    const buffer = Buffer.from(publicKeyHash, "hex");
    const bcoinNetwork = (0, bitcoin_network_1.toBcoinNetwork)(network);
    return witness
        ? bcoin_1.default.Address.fromWitnessPubkeyhash(buffer).toString(bcoinNetwork)
        : bcoin_1.default.Address.fromPubkeyhash(buffer).toString(bcoinNetwork);
}
exports.encodeToBitcoinAddress = encodeToBitcoinAddress;
/**
 * Decodes P2PKH or P2WPKH address into a public key hash. Throws if the
 * provided address is not PKH-based.
 * @param address - P2PKH or P2WPKH address that will be decoded.
 * @returns Public key hash decoded from the address. This will be an unprefixed
 *        hex string (without 0x prefix).
 */
function decodeBitcoinAddress(address) {
    const addressObject = new bcoin_1.default.Address(address);
    const isPKH = addressObject.isPubkeyhash() || addressObject.isWitnessPubkeyhash();
    if (!isPKH) {
        throw new Error("Address must be P2PKH or P2WPKH");
    }
    return addressObject.getHash("hex");
}
exports.decodeBitcoinAddress = decodeBitcoinAddress;
/**
 * Checks if given public key hash has proper length (20-byte)
 * @param publicKeyHash - text that will be checked for the correct length
 * @returns true if the given string is 20-byte long, false otherwise
 */
function isPublicKeyHashLength(publicKeyHash) {
    return publicKeyHash.length === 40;
}
exports.isPublicKeyHashLength = isPublicKeyHashLength;
/**
 * Converts Bitcoin specific locktime value to a number. The number represents
 * either a block height or an Unix timestamp depending on the value.
 *
 * If the number is less than 500 000 000 it is a block height.
 * If the number is greater or equal 500 000 000 it is a Unix timestamp.
 *
 * @see {@link https://developer.bitcoin.org/devguide/transactions.html#locktime-and-sequence-number Documentation}
 *
 * @param locktimeLE A 4-byte little-endian locktime as an un-prefixed
 *                   hex string {@link: Deposit#refundLocktime}.
 * @returns UNIX timestamp in seconds.
 */
function locktimeToNumber(locktimeLE) {
    const locktimeBE = hex_1.Hex.from(locktimeLE).reverse().toBuffer();
    return ethers_1.BigNumber.from(locktimeBE).toNumber();
}
exports.locktimeToNumber = locktimeToNumber;
/**
 * Creates the output script from the BTC address.
 * @param address BTC address.
 * @returns The un-prefixed and not prepended with length output script.
 */
function createOutputScriptFromAddress(address) {
    return hex_1.Hex.from(bcoin_1.Script.fromAddress(address).toRaw().toString("hex"));
}
exports.createOutputScriptFromAddress = createOutputScriptFromAddress;
/**
 * Creates the Bitcoin address from the output script.
 * @param script The unprefixed and not prepended with length output script.
 * @param network Bitcoin network.
 * @returns The Bitcoin address.
 */
function createAddressFromOutputScript(script, network = bitcoin_network_1.BitcoinNetwork.Mainnet) {
    var _a;
    return (_a = bcoin_1.Script.fromRaw(script.toString(), "hex")
        .getAddress()) === null || _a === void 0 ? void 0 : _a.toString((0, bitcoin_network_1.toBcoinNetwork)(network));
}
exports.createAddressFromOutputScript = createAddressFromOutputScript;
//# sourceMappingURL=bitcoin.js.map